import { type MouseEvent as ReactMouseEvent, useCallback } from 'react'
import { type NavigateOptions, useNavigate } from 'react-router'

export function useNavigateFromClickEvent(): (
  to: string,
  event: MouseEvent | ReactMouseEvent,
  options?: NavigateOptions
) => void {
  const navigate = useNavigate()
  return useCallback(
    (
      to: string,
      event: MouseEvent | ReactMouseEvent,
      options?: NavigateOptions
    ) => {
      if (event.metaKey || event.ctrlKey) {
        window.open(to, '_blank')
      } else {
        void navigate(to, options)
      }
    },
    [navigate]
  )
}
